import { PropsWithChildren } from 'react';
import { useCurrentUser } from '../../../common/auth/hooks/use-current-user';

export function AdminOnly({ children }: PropsWithChildren<{}>) {
  const { isAdmin } = useCurrentUser();
  if (!isAdmin) return null;
  return <>{children}</>;
}
